import { atom } from "recoil";
export const remixModal = atom({
  key: "remixModal", // unique ID (with respect to other atoms/selectors)
  default: !localStorage.getItem("noRemixModal"), // default value (aka initial value)
});
